module.exports = __webpack_public_path__ + "puzzle-2ykaukc.svg";